export default "/fonts/vendor/simple-line-icons/Simple-Line-Icons.ttf?3ec13a24af3fdda1110771d3541915a2";